import {
  admin,
  documents
} from "./chunk-MC2WDLJQ.js";
import {
  DEFAULT_APP_LOCALE,
  DEFAULT_NAMESPACE,
  LOCALES,
  LOCALE_STORAGE_KEY,
  NAMESPACES,
  auth,
  common,
  errors,
  getDirection,
  interpolate,
  isAppLocale,
  toIntlLocale,
  toValidationKey,
  validation,
  web
} from "./chunk-KE26HA2Q.js";

// src/admin.ts
var ADMIN_NAMESPACES = [
  "common",
  "auth",
  "validation",
  "errors",
  "web",
  "admin",
  "documents"
];
var TR_ADMIN_RESOURCES = {
  common,
  auth,
  validation,
  errors,
  web,
  admin,
  documents
};
function loadAdminResources(locale) {
  switch (locale) {
    case "tr":
      return Promise.resolve(TR_ADMIN_RESOURCES);
    case "en":
      return import("./en-admin-36OQ7IRT.js").then(
        ({ resources }) => resources
      );
    case "ar":
      return import("./ar-admin-NSNJC26I.js").then(
        ({ resources }) => resources
      );
    case "ru":
      return import("./ru-admin-5LZ4645K.js").then(
        ({ resources }) => resources
      );
  }
}
export {
  ADMIN_NAMESPACES,
  DEFAULT_APP_LOCALE,
  DEFAULT_NAMESPACE,
  LOCALES,
  LOCALE_STORAGE_KEY,
  NAMESPACES,
  TR_ADMIN_RESOURCES,
  getDirection,
  interpolate,
  isAppLocale,
  loadAdminResources,
  toIntlLocale,
  toValidationKey
};
//# sourceMappingURL=admin.js.map